import { useEffect, useRef, useState } from 'react';

/**
 * Google AdSense Banner Component
 * Usage: <AdBanner adSlot="8611844882" />
 */
export default function AdBanner({ adSlot }: { adSlot: string }) {
  const adRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    // Only push if the ad container is visible and has width
    const tryPushAd = () => {
      if (adRef.current && adRef.current.offsetWidth > 0) {
        try {
          // @ts-ignore
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
          // Ignore duplicate push errors
        }
      } else {
        setTimeout(tryPushAd, 300);
      }
    };
    tryPushAd();
    // Show ad container if ad loads (height increases)
    timeoutId = setTimeout(() => {
      if (adRef.current && adRef.current.offsetHeight > 120) {
        setShow(true);
      } else {
        setShow(false);
      }
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, []);

  if (!show) return null;

  return (
    <div ref={adRef} style={{ minWidth: 320, minHeight: 100, width: '100%', background: '#181818', borderRadius: 8 }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', minWidth: 320, minHeight: 100, background: '#181818', borderRadius: 8 }}
        data-ad-client="ca-pub-5253114725535870"
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
}
